module.exports = __webpack_public_path__ + "static/Rebecca-11b11268a8ce80058712f5e1e17ec23c.jpeg";